export interface CommunityRouter {
  goToList(query?: string): void;
  goToDetail(id: string, slug: string): void;
  goToEdit(id: string, slug: string, query?: string, hash?: string): void;
  goToCreate(accountId: string): void;
  goToInvite(id: string, slug: string, query?: string): void;
  goToAutoJoinSettings(id: string, slug: string, query?: string): void;
  goToManageUsers(id: string, slug: string, query?: string): void;
  goToCommunityUsers(id: string, slug: string, query?: string): void;
  goToPostDetail(id: string, slug: string, postId: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommunityRouter = Symbol('CommunityRouter');
